import React, { useEffect, useState } from 'react';
import './Wallet.css';
import { getApi } from '../../services/api';

const Wallet = () => {
  const [walletData, setWalletData] = useState(null);
  const [stakeHistory, setStakeHistory] = useState([]);
  const [directIncome, setDirectIncome] = useState([]);
  const [matchingIncome, setMatchingIncome] = useState([]);
  const [pagination, setPagination] = useState(null);
  const [loading, setLoading] = useState(true);
  const [tableLoading, setTableLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [tabelView, setTableview] = useState('stake_income');

  const getWallets = async () => {
    try {
      const response = await getApi('wallets');
      setWalletData(response.data?.data || response.data);
    } catch (error) {
      console.error('Wallet fetch error:', error);
    } finally {
      setLoading(false);
    }
  };

  const getStakeHistory = async (page = 1) => {
    setTableLoading(true);
    try {
      const response = await getApi(`stakehistory?page=${page}`);
      setStakeHistory(response.data?.data || []);
      setPagination(response.data?.pagination || null);
      setCurrentPage(page);
      setTableview('stake_income');
    } catch (error) {
      console.error('Stake history fetch error:', error);
    } finally {
      setTableLoading(false);
    }
  };

  useEffect(() => {
    getWallets();
    getStakeHistory(1);
  }, []);

  const openDirectIncome = async (page = 1) => {
    setTableLoading(true);
    try {
      const response = await getApi(`direct-income?page=${page}`);
      setDirectIncome(response.data?.data || []);
      setPagination(response.data?.pagination || null);
      setCurrentPage(page);
      setTableview('directincome_table');
    } catch (error) {
      console.error('Direct income fetch error:', error);
    } finally {
      setTableLoading(false);
    }
  };

  const openMatchingIncome = async (page = 1) => {
    setTableLoading(true);
    try {
      const response = await getApi(`matching-income?page=${page}&per_page=10`);
      setMatchingIncome(response.data?.data || []);
      setPagination(response.data?.pagination || null);
      setCurrentPage(page);
      setTableview('matching_income');
    } catch (error) {
      console.error('Matching income fetch error:', error);
    } finally {
      setTableLoading(false);
    }
  };

  const handlePageChange = (page) => {
    if (page < 1 || (pagination && page > pagination.last_page)) return;
    if (tabelView === 'stake_income') {
      getStakeHistory(page);
    } else if (tabelView === 'directincome_table') {
      openDirectIncome(page);
    } else if (tabelView === 'matching_income') {
      openMatchingIncome(page);
    }
  };

  const balanceCards = [
    { label: 'Total Balance',    value: walletData?.total_amount || 0,    icon: 'bi-wallet2',    color: 'green',  desc: 'Lifetime earnings' },
    { label: 'Withdraw Balance', value: walletData?.withdraw_amount || 0, icon: 'bi-cash-stack', color: 'red',    desc: 'Available to withdraw' },
    { label: 'Remain Balance',   value: walletData?.remain_amount || 0,   icon: 'bi-piggy-bank', color: 'yellow', desc: 'Accumulated rewards' },
  ];

  const incomeCards = [
    { label: 'Stake Income',    value: walletData?.stake_income || 0,    icon: 'bi-layers',        onClick: () => getStakeHistory(1),   active: tabelView === 'stake_income' },
    { label: 'Direct Income',   value: walletData?.direct_income || 0,   icon: 'bi-people',        onClick: () => openDirectIncome(1),  active: tabelView === 'directincome_table' },
    { label: 'Matching Income', value: walletData?.matching_income || 0, icon: 'bi-diagram-3',     onClick: () => openMatchingIncome(1), active: tabelView === 'matching_income' },
    { label: 'Rank Income',     value: walletData?.rank_income || 0,     icon: 'bi-trophy',        onClick: null,                        active: false },
  ];

  return (
    <div className="page-wrapper">
      {/* Header */}
      <div className="page-header mb-4">
        <div className="section-label">Finance</div>
        <h2 className="page-title">Wallet</h2>
        <p className="page-subtitle">Manage your digital assets and transaction history</p>
      </div>

      {/* Balance Cards */}
      <div className="row g-3 mb-4">
        {balanceCards.map((card, i) => (
          <div key={i} className="col-lg-4">
            {loading ? (
              <div className="skeleton" style={{ height: 110, borderRadius: 18 }}></div>
            ) : (
              <div className={`metric-card ${card.color}`} style={{ flexDirection: 'column', alignItems: 'flex-start', padding: '1.5rem', position: 'relative', overflow: 'hidden' }}>
                <div className="d-flex justify-content-between w-100 mb-3">
                  <div className={`metric-icon ${card.color}`}>
                    <i className={`bi ${card.icon}`}></i>
                  </div>
                  <span style={{ fontSize: '0.75rem', color: 'rgba(255,255,255,0.4)', alignSelf: 'flex-start', fontWeight: 600 }}>{card.desc}</span>
                </div>
                <div className="metric-label">{card.label}</div>
                <div className="metric-value" style={{ fontSize: '1.8rem' }}>
                  <span style={{ fontSize: '1rem', marginRight: 2, opacity: 0.7 }}>$</span>
                  {parseFloat(card.value).toLocaleString()}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Income Type Cards */}
      <div className="row g-3 mb-4">
        {incomeCards.map((card, i) => (
          <div key={i} className="col-md-3 col-6">
            {loading ? (
              <div className="skeleton" style={{ height: 90, borderRadius: 16 }}></div>
            ) : (
              <button
                onClick={card.onClick}
                disabled={!card.onClick}
                className="w-100 text-start"
                style={{
                  background: card.active ? 'rgba(0,255,149,0.08)' : 'rgba(255,255,255,0.02)',
                  border: card.active ? '1px solid rgba(0,255,149,0.35)' : '1px solid rgba(255,255,255,0.07)',
                  borderRadius: 16, padding: '1rem 1.1rem', cursor: card.onClick ? 'pointer' : 'default',
                  transition: 'all 0.25s', color: 'white', fontFamily: 'Inter, sans-serif',
                  boxShadow: card.active ? '0 0 20px rgba(0,255,149,0.1)' : 'none',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
                  <i className={`bi ${card.icon}`} style={{ color: card.active ? 'var(--page-accent)' : 'rgba(255,255,255,0.5)', fontSize: '1rem' }}></i>
                  {card.onClick && <span style={{ fontSize: '0.68rem', color: 'rgba(255,255,255,0.4)', marginLeft: 'auto' }}>click to view</span>}
                </div>
                <div style={{ fontSize: '0.78rem', color: 'rgba(255,255,255,0.5)', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em' }}>{card.label}</div>
                <div style={{ fontSize: '1.2rem', fontWeight: 800, fontFamily: 'JetBrains Mono, monospace', color: card.active ? 'var(--page-accent)' : 'white' }}>${card.value}</div>
              </button>
            )}
          </div>
        ))}
      </div>

      {/* Table View */}
      <div className="p-card">
        <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2">
          <div>
            <p className="section-label mb-0">Transaction Log</p>
            <h5 style={{ margin: 0, fontWeight: 700 }}>
              {tabelView === 'stake_income' 
                ? 'Stake History' 
                : tabelView === 'directincome_table' 
                ? 'Direct Income History' 
                : 'Matching Income History'}
            </h5>
          </div>
          <div className="d-flex gap-2">
            <button onClick={() => getStakeHistory(1)}
              style={{ padding: '6px 14px', borderRadius: 10, fontSize: '0.82rem', fontWeight: 600, fontFamily: 'Inter, sans-serif', cursor: 'pointer', transition: 'all 0.2s',
                background: tabelView === 'stake_income' ? 'rgba(0,255,149,0.15)' : 'rgba(255,255,255,0.05)',
                color: tabelView === 'stake_income' ? 'var(--page-accent)' : 'rgba(255,255,255,0.6)',
                border: tabelView === 'stake_income' ? '1px solid rgba(0,255,149,0.3)' : '1px solid rgba(255,255,255,0.1)' }}>
              Stake
            </button>
            <button onClick={() => openDirectIncome(1)}
              style={{ padding: '6px 14px', borderRadius: 10, fontSize: '0.82rem', fontWeight: 600, fontFamily: 'Inter, sans-serif', cursor: 'pointer', transition: 'all 0.2s',
                background: tabelView === 'directincome_table' ? 'rgba(0,255,149,0.15)' : 'rgba(255,255,255,0.05)',
                color: tabelView === 'directincome_table' ? 'var(--page-accent)' : 'rgba(255,255,255,0.6)',
                border: tabelView === 'directincome_table' ? '1px solid rgba(0,255,149,0.3)' : '1px solid rgba(255,255,255,0.1)' }}>
              Direct
            </button>
            <button onClick={() => openMatchingIncome(1)}
              style={{ padding: '6px 14px', borderRadius: 10, fontSize: '0.82rem', fontWeight: 600, fontFamily: 'Inter, sans-serif', cursor: 'pointer', transition: 'all 0.2s',
                background: tabelView === 'matching_income' ? 'rgba(0,255,149,0.15)' : 'rgba(255,255,255,0.05)',
                color: tabelView === 'matching_income' ? 'var(--page-accent)' : 'rgba(255,255,255,0.6)',
                border: tabelView === 'matching_income' ? '1px solid rgba(0,255,149,0.3)' : '1px solid rgba(255,255,255,0.1)' }}>
              Matching
            </button>
          </div>
        </div>

        <div className="p-table-wrap">
          {tableLoading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-success"></div>
            </div>
          ) : tabelView === 'stake_income' ? (
            stakeHistory.length === 0 ? (
              <div className="empty-state">
                <div className="empty-icon"><i className="bi bi-layers"></i></div>
                <h6>No Stake History</h6>
                <p>Your staking transactions will appear here</p>
              </div>
            ) : (
              <table className="p-table">
                <thead>
                  <tr><th>ID</th><th>Trade Amount</th><th>Trade Profit</th><th>Margin</th><th>Date</th><th>Status</th></tr>
                </thead>
                <tbody>
                  {stakeHistory.map(item => (
                    <tr key={item.id}>
                      <td className="dim mono">#{item.id}</td>
                      <td style={{ fontWeight: 700, color: 'var(--page-accent)' }}>${item.trade_amount}</td>
                      <td className="mono">${item.trade_profit}</td>
                      <td style={{ color: 'var(--page-blue)' }}>{item.profit_margin}%</td>
                      <td className="dim" style={{ fontSize: '0.8rem' }}>{new Date(item.date_time).toLocaleString()}</td>
                      <td><span className={`s-pill ${(item.status || '').toLowerCase()}`}>{item.status}</span></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )
          ) : tabelView === 'directincome_table' ? (
            directIncome.length === 0 ? (
              <div className="empty-state">
                <div className="empty-icon"><i className="bi bi-people"></i></div>
                <h6>No Direct Income</h6>
                <p>Referral earnings will appear here</p>
              </div>
            ) : (
              <table className="p-table">
                <thead>
                  <tr><th>User</th><th>Stake Amount</th><th>Reward %</th><th>Reward</th><th>Date</th></tr>
                </thead>
                <tbody>
                  {directIncome.map(item => (
                    <tr key={item.id}>
                      <td><span className="u-code">{item.name?.slice(0, 4)}••••{item.name?.slice(-4)}</span></td>
                      <td style={{ fontWeight: 700 }}>${item.stake_amount}</td>
                      <td style={{ color: 'var(--page-blue)' }}>{item.reward_percentage}%</td>
                      <td style={{ color: 'var(--page-accent)', fontWeight: 700 }}>${item.reward_amount}</td>
                      <td className="dim" style={{ fontSize: '0.8rem' }}>{new Date(item.date_time).toLocaleString()}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )
          ) : (
            matchingIncome.length === 0 ? (
              <div className="empty-state">
                <div className="empty-icon"><i className="bi bi-diagram-3"></i></div>
                <h6>No Matching Income</h6>
                <p>Matching income bonuses will appear here</p>
              </div>
            ) : (
              <table className="p-table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Left Business</th>
                    <th>Right Business</th>
                    <th>Match Business</th>
                    <th>Reward %</th>
                    <th>Reward</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {matchingIncome.map(item => (
                    <tr key={item.id}>
                      <td className="dim mono">#{item.id}</td>
                      <td style={{ fontWeight: 600 }}>${Number(item.new_left_business || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                      <td style={{ fontWeight: 600 }}>${Number(item.new_right_business || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                      <td style={{ fontWeight: 700, color: 'var(--page-accent)' }}>${Number(item.match_business || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                      <td style={{ color: 'var(--page-blue)' }}>{item.reward_percentage}%</td>
                      <td style={{ color: 'var(--page-accent)', fontWeight: 700 }}>${Number(item.reward_amount || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                      <td className="dim" style={{ fontSize: '0.8rem' }}>{new Date(item.date_time).toLocaleString()}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )
          )}
        </div>

        {/* Pagination */}
        {pagination && pagination.last_page > 1 && (
          <div className="d-flex justify-content-between align-items-center mt-4 flex-wrap gap-2" style={{ paddingTop: '1rem', borderTop: '1px solid var(--card-border)' }}>
            <span style={{ fontSize: '0.82rem', color: 'var(--text-secondary)' }}>
              Showing {pagination.from}–{pagination.to} of {pagination.total}
            </span>
            <div className="d-flex gap-1">
              <button className="copy-btn" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>← Prev</button>
              {Array.from({ length: Math.min(pagination.last_page, 7) }, (_, i) => i + 1).map(page => (
                <button key={page} onClick={() => handlePageChange(page)}
                  style={{ padding: '4px 10px', borderRadius: 8, fontSize: '0.8rem', fontWeight: 700, border: 'none', cursor: 'pointer', fontFamily: 'Inter, sans-serif',
                    background: currentPage === page ? 'var(--page-accent)' : 'rgba(255,255,255,0.06)',
                    color: currentPage === page ? '#071B12' : 'rgba(255,255,255,0.6)' }}>
                  {page}
                </button>
              ))}
              <button className="copy-btn" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === pagination.last_page}>Next →</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Wallet;